import { render } from "./accountTitles.vue?vue&type=template&id=7d96ad45"
import script from "./accountTitles.vue?vue&type=script&lang=js"
export * from "./accountTitles.vue?vue&type=script&lang=js"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__